<template>
    <div class="status-filter">
      <label for="status-select">Статус:</label>
      <select id="status-select" v-model="selectedStatus" @change="emitStatus">
        <option value="">Все</option>
        <option v-for="status in initialStatus" :key="status.value" :value="status.value">
          {{ status.name }}
        </option>
      </select>
    </div>
  </template>
  
  <script>
  export default {
    name: 'StatusFilter',
    props: {
      initialStatus: {
        type: String,
        default: '',
      },
    },
    emits: ['update:status'],
    data() {
      return {
        selectedStatus: this.initialStatus,
      };
    },
    methods: {
      emitStatus() {
        this.$emit('update:status', this.selectedStatus);
      },
    },
  };
  </script>
  
  <style scoped>
  .status-filter {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 15px;
  }
  
  .status-filter label {
    margin-right: 10px;
    font-size: 14px;
  }
  
  .status-filter select {
    padding: 5px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }
  </style>